<template>
  <modal
    :show="true"
    :large="true"
    v-on:close="closeModal"
    :enable-event="!alertIsOpen"
  >
    <div slot="title">
      <h4>Edit Witness</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            :options="titles"
            v-model="form.title_id"
            label="Title"
            name="title"
            placeholder="Please Select"
          ></selectlist>

          <inputbox
            v-model="form.first_name"
            name="first_name"
            label="First Name"
          ></inputbox>

          <inputbox
            v-model="form.last_name"
            name="last_name"
            label="Last Name"
          ></inputbox>

          <inputbox
            v-model="form.telephone"
            name="telephone"
            label="Telephone"
          ></inputbox>

          <inputbox
            v-model="form.email_address"
            name="email"
            label="Email Address"
            type="email"
          ></inputbox>

          <address-lookup
            :address="address"
            v-on:address="setAddress"
          ></address-lookup>

          <toggleswitch
            :labels="true"
            name="corroborate"
            label="Corroborate Clients Version of Events?"
            v-model="form.corroborate"
          ></toggleswitch>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button
        class="btn btn-danger float-left"
        type="button"
        v-on:click="deleteWitness"
      >
        Delete
      </button>
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <button v-on:click="updateWitness" type="button" class="btn btn-primary">
        Update Witness
      </button>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    titles: {
      type: Array,
      required: true
    },

    witness: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      alertIsOpen: false,
      form: new window.Form({
        title_id: this.witness.title_id,
        first_name: this.witness.first_name,
        last_name: this.witness.last_name,
        email_address: this.witness.email_address,
        telephone: this.witness.telephone,
        address_line_one: this.witness.address_line_one,
        address_line_two: this.witness.address_line_two,
        city: this.witness.city,
        postcode: this.witness.postcode,
        corroborate: this.witness.corroborate
      })
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    closeModal() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    deleteWitness() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            window.Ajax.delete(
              '/incidents/' +
                this.incident +
                '/witnesses/' +
                this.witness.identifier
            )
              .then(response => {
                this.$emit('deleted', this.witness);
              })
              .catch(error => {
                window.toastify.error(
                  'Error',
                  'Sorry, there was an issue deleting the witness.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    updateWitness() {
      this.form
        .put(
          '/incidents/' +
            this.incident +
            '/witnesses/' +
            this.witness.identifier
        )
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(response => {
          window.toastify.error('Please complete the required fields');
        });
    }
  }
};
</script>
